var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.023,
    height: 67.023,
    viewBox: "0 0 67.023 67.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26356",
    "data-name": "Group 26356",
    transform: "translate(-526.452 -529.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13561",
    "data-name": "Group 13561",
    transform: "translate(526.452 529.005)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 33.512,
    cy: 33.512,
    r: 33.512,
    fill: "#2c53bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10173",
    "data-name": "Path 10173",
    d: "M-6539.151-5774.893h37.2v2.977h-37.2Z",
    transform: "translate(6554.029 5806.881)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorAlert);
export default __webpack_public_path__ + "static/media/error-alert.a85009e77983ffc0b8b7296426fcb26b.svg";
export { ForwardRef as ReactComponent };